import React, { useEffect, useState } from "react";
import {
  Button,
  HeaderStyle,
  InfoText,
  Divider,
  Alert,
  Modal,
  showToast,
  Backdrop,
  LogoLoader,
  FormFieldSet,
  SmartTooltip,
  TableAdv,
  InfoWrapper,
  InfoCardNewAdv,
  CopyToClipboard,
  DualIcon,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import ViewLeadModal from "./MyLeads/ViewLeadModal";
import JobDetailsModal from "./MyLeads/JobDetailsModal";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchJobById,
  fetchJobsByMultipleIds,
  fetchProspects,
  deleteJobApi,
  deleteCompanyApi,
} from "../../../../redux/slices/leads/leadsApi";
import {
  getTodaysCompaniesStart,
  getTodaysCompanyJobCountsStart,
} from "../../../../redux/slices/leads/leadsSlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import dayjs from "dayjs";
import ImportModal from "./MyLeads/ImportModal";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { formatWords2 } from "../../../../utils/stringUtils";
import MyLeadsPreview from "./Modals/MyLeadsPreview";
import {
  getEndOfDay,
  getStartOfDay,
  sanitizeString,
} from "../../../../utils/common";
import { usePagination } from "../../../../hooks";

const MyLeads = () => {
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const [showDataId, setShowDataId] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [editCompanyId, setEditCompanyId] = useState(null);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [deleteLeadId, setDeleteLeadId] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editJobData, setEditJobData] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [rawParsedData, setRawParsedData] = useState([]);
  const [newViewData, setNewViewData] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notesData, setNotesData] = useState("");

  // const todayCounts = companyJobCounts?.today?.data?.[0] || {};
  const [searchText, setSearchText] = useState("");
  // Ref to track if the edit modal is opened from the Preview modal.
  // This prevents the data from being overwritten by a subsequent fetch in handleOpenEditModal.
  const isComingFromPreview = React.useRef(false);

  const dispatch = useDispatch();
  const { companies = [] } = useSelector((state) => state?.leads?.leads || {});
  const { loading } = useSelector((state) => state?.leads);
  const { companyJobCounts } = useSelector((state) => state?.leads || {});
  const { today, yesterday } = companyJobCounts || {};
  const todayCounts = today?.data[0] || {};
  const yesterdayCounts = yesterday?.data[0] || {};
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  // Inside MyLeads component
  const [openImportModal, setOpenImportModal] = useState(false);
  const [excelFile, setExcelFile] = useState([]);
  const [csvFile, setCsvFile] = useState([]);
  const [parsedData, setParsedData] = useState([]);
  const [editComapany, setEditCompany] = useState({});
  const [isPreviewModal, setIsPreviewModel] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [myLeadsErrors, setMyLeadsErrors] = useState([]);

  const handleGetJobDeatilsAPI = async (row) => {
    setShowDataId(row?.id);
    try {
      const job = row?.jobId ? await fetchJobById(row?.jobId) : {};
      const company = companies.find((c) =>
        (c.jobs || []).some((j) => j?.uiid === row?.jobId),
      );
      // const company =
      //   companies.find((c) =>
      //     (c.jobs || []).some((j) => j.uiid === row.jobId)
      //   ) || companies.find((c) => c.uiid === row.companyId);

      const contacts = (job?.prospectIds || []).map((p) => ({
        name: `${p?.firstName} ${p?.lastName}`,
        designation: p?.designation,
        location: p?.location || "-",
        email: p?.email?.email || "-",
        phone: p?.mobile?.number
          ? `${p?.mobile?.code} ${p?.mobile?.number}`
          : "-",
        uiid: p?.uiid,
      }));

      setEditJobData({
        id: job?.uiid,
        companyName: company?.name || "-",
        website: company?.website || "",
        industry: company?.industry || "",
        jobTitle: job?.title || "",
        // jobLocation: job?.location
        //   ? `${job?.location?.city || "-"}, ${job?.location?.state || "-"}, ${
        //       job?.location?.country || "-"
        //     }`
        //   : "-",
        jobLocation: job?.location
          ? [job?.location?.city, job?.location?.state, job?.location?.country]
              .filter(Boolean)
              .join(", ")
          : "-",
        jobDescription: job?.description || "",
        comment: job?.comment || "",
        contactDetails: contacts,
        jobId: job?.uiid,
        companyId: company?.uiid,
      });
    } catch (error) {
      console.error("Failed to fetch job details", error);
      setEditJobData(null);
    } finally {
    }
  };
  const companyApprovalStatus = {
    1: "Pending",
    2: "Approved",
    3: "Rejected",
  };

  const companyApprovalStatusColor = {
    1: "text-yellow-600 bg-yellow-100", // Pending
    2: "text-green-700 bg-green-100", // Approved
    3: "text-red-600 bg-red-100", // Rejected
  };

  const columns = [
    {
      key: "companyName",
      label: "Account Name",
      width: "min-w-[250px] max-w-[300px]",
      render: (row) => {
        const isToday =
          new Date(row?.companyAddedOn).toDateString() ===
          new Date().toDateString();

        const approval = row?.approvalStatus;

        const statusCode = approval?.isEnabled ? approval.status : null;

        const statusText = statusCode
          ? companyApprovalStatus[statusCode]
          : null;

        const statusColor = statusCode
          ? companyApprovalStatusColor[statusCode]
          : "";

        return (
          <SmartTooltip description={formatWords2(row.companyName)} noicon>
            <div className="flex items-center gap-2">
              <div
                className="text-info cursor-pointer line-clamp-1"
                onClick={() => handleGetJobDeatilsAPI(row)} // side panel trigger
              >
                {/* {row.companyName} */}
                {formatWords2(row.companyName)}
              </div>

              {isToday && statusText && (
                <small
                  className={`text-[10px] font-medium px-2 py-[2px] rounded-md ${statusColor}`}
                >
                  {statusText}
                </small>
              )}
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px] max-w-[300px]",
      render: (row) => (
        <SmartTooltip description={formatWords2(row.jobTitle)} noicon>
          <div className="line-clamp-1">{formatWords2(row.jobTitle)}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobLocation",
      label: "Job Location",
      width: "min-w-[250px] max-w-[300px]",
      render: (row) => (
        <SmartTooltip description={formatWords2(row.jobLocation)} noicon>
          <div className="line-clamp-1">{row.jobLocation}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobDescription",
      label: "Job Description",
      width: "min-w-[150px] max-w-[200px]",
      // className: "flex-1",
      render: (row) => (
        <div className="flex-1 flex items-center gap-2">
          {/* {row.jobDescription && typeof row.jobDescription === "string" ? */}
          {row.jobDescription &&
          row.jobDescription.trim() !== "" &&
          row.jobDescription.trim() !== "-" ? (
            <a
              href={normalizeUrl(row.jobDescription)}
              target="_blank"
              className="text-info  hover:underline cursor-pointer"
              rel="noreferrer"
            >
              {/* {row.jobDescription}  */}
              {getSiteName(row.jobDescription)}
            </a>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      key: "contactDetails",
      label: "Contact Details",
      width: "min-w-[150px] max-w-[200px]",
      render: (row) => (
        <div className="flex-1 flex items-center gap-2">
          <div className="w-fit truncate overflow-hidden whitespace-nowrap">
            <span className="text-success">{row?.contactDetails || 0}</span>
            /5
          </div>
        </div>
      ),
    },
    {
      key: "",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center justify-between gap-2">
          {row?.comment && (
            <SmartTooltip description={"Note"} noicon>
              <DualIcon
                size="sm"
                icon="chat"
                onClick={() => {
                  setIsModalOpen(true);
                  setNotesData(row?.comment);
                }}
              />
            </SmartTooltip>
          )}
          <SmartTooltip description={"View"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="visibility"
              size="xs"
              color="black"
              onClick={() => {
                setViewData(row);
                setOpenViewModal(true);
                setEditCompany({
                  companyName: row.companyName,
                  companyId: row.companyId,
                });
                fetchFullViewData(row);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description={"Edit"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="edit_square"
              size="xs"
              color="black"
              onClick={() =>
                handleOpenEditModal(row.jobId, row.companyId, row.companyName)
              }
            />
          </SmartTooltip>
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              size="xs"
              color="black"
              onClick={() => {
                // setDeleteLeadId(row.id);
                setDeleteLeadId(row.companyId);
                setCompanyName(row?.companyName);
                setShowDeleteAlert(true);
              }}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const fetchFullViewData = async (row) => {
    try {
      const response = await fetchProspects({
        filters: { uiid: { type: "IN", value: row?.prospectIds } },
        ret: "firstName lastName designation email mobile location",
      });

      const prospectData = response?.data?.data || [];

      const contactDetails = prospectData.map((prospect) => ({
        name: `${prospect?.firstName || ""} ${prospect?.lastName || ""}`.trim(),
        designation: prospect?.designation || "-",
        email: prospect?.email || "-",
        phone: prospect?.mobile
          ? `${prospect?.mobile?.code || ""} ${prospect?.mobile?.number || ""}`
          : "-",
        location: [
          prospect?.location?.city,
          prospect?.location?.state,
          prospect?.location?.country,
        ]
          .filter(Boolean)
          .join(", "),
      }));
      const mergedData = {
        companyName: row?.companyName || "-",
        website: row?.website || "-",
        companyId: row?.companyId || null,
        jobTitle: row?.jobTitle || "-",
        jobDescription: row?.jobDescription || "-",
        jobLocation: row?.jobLocation || "-",
        contactDetails,
      };
      setNewViewData(mergedData);
    } catch (err) {
      console.error("Error fetching prospects:", err);
      showToast("Failed to fetch prospect data. Please try again.", "error");
    }
  };

  const handleOpenPreview = async () => {
    try {
      setMyLeadsErrors([]);
      if (!companies?.length) return;

      const allProspectIds = companies.flatMap((company) =>
        company.jobs?.flatMap((job) => job?.prospectIds || []),
      );

      // if (!allProspectIds.length) {
      //   setPreviewData([]);
      //   setIsPreviewModel(true);
      //   return;
      // };
      const response = await fetchProspects({
        filters: { uiid: { type: "IN", value: allProspectIds } },
        ret: "uiid firstName lastName designation email mobile location",
        limit: allProspectIds.length,
      });

      const prospects = response?.data?.data || [];
      const prospectMap = {};
      prospects.forEach((p) => {
        prospectMap[p.uiid] = p;
      });

      const formattedData = companies.flatMap((company) => {
        const jobs = company.jobs?.length ? company.jobs : [null];
        return jobs?.map((job) => ({
          companyId: company?.uiid,
          jobId: job?.uiid || null,
          companyName: company?.name,
          approvalStatus: company?.approvalStatus,
          companyAddedOn: company?.addedOn,
          website: company?.website,
          industry: company?.industry,
          jobTitle: job?.title,
          jobDescription: job?.description,
          comment: job?.comment || company?.comment || "",
          jobLocation: [
            job?.location?.city,
            job?.location?.state,
            job?.location?.country,
          ]
            .filter(Boolean)
            .join(", "),
          contactDetails: (job?.prospectIds || [])
            .map((id) => {
              const p = prospectMap[id];
              if (!p) return null;
              const phone =
                p?.mobile && (p?.mobile?.code || p?.mobile?.number)
                  ? {
                      code: p?.mobile?.code || "",
                      number: p?.mobile?.number || "",
                      display: `${p?.mobile?.code || ""} ${
                        p?.mobile.number || ""
                      }`.trim(),
                    }
                  : null;
              return {
                name: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
                designation: p?.designation || "",
                email: p?.email || "",
                phone: phone,
                location: p?.location || "-",
                // location: [
                //   p.location?.city,
                //   p.location?.state,
                //   p.location?.country,
                // ]
                //   .filter(Boolean)
                //   .join(", "),
              };
            })
            .filter(Boolean),
        }));
      });

      setPreviewData(formattedData);
      setIsPreviewModel(true);
    } catch (error) {
      console.error("Error fetching preview data:", error);
    }
  };

  const handlePreviewEditClick = (jobData) => {
    isComingFromPreview.current = true; // Set flag to indicate we are coming from Preview
    // jobData is passed from the preview modal
    setOpenEditModal(true);
    setIsPreviewModel(false);
    setEditCompanyId(jobData.companyId);
    setEditCompany({
      companyName: jobData?.companyName,
      companyId: jobData?.companyId,
    });

    // use existing jobData instead of API fetch
    const contacts = (jobData?.contactDetails || []).map((c) => ({
      name: c?.name || "-",
      designation: c?.designation || "-",
      email: c?.email || "-",
      // phone: c.phone || "-",
      phone: c?.phone ? `${c?.phone?.code} ${c?.phone?.number}` : "-",
      location: c?.location || "-",
    }));

    setEditJobData({
      id: jobData?.jobId,
      companyName: jobData?.companyName || "-",
      website: jobData?.website || "",
      industry: jobData?.industry || "",
      jobTitle: jobData?.jobTitle || "-",
      jobLocation: jobData?.jobLocation || "-",
      jobDescription: jobData?.jobDescription || "",
      comment: jobData?.comment || "",
      contactDetails: contacts,
      jobId: jobData?.jobId,
      companyId: jobData?.companyId,
    });
  };

  const handleSubmit = async () => {
    try {
      if (!companies?.length) return;

      // Collect prospect IDs
      const allProspectIds = companies.flatMap((company) =>
        company.jobs?.flatMap((job) => job?.prospectIds || []),
      );

      // if (!allProspectIds.length) {
      //   toast.error("No prospects found for submission.");
      //   return;
      // }

      // Fetch prospect details
      const response = await fetchProspects({
        filters: { uiid: { type: "IN", value: allProspectIds } },
        ret: "uiid firstName lastName designation email mobile location",
        limit: allProspectIds.length,
      });

      const prospects = response?.data?.data || [];
      const prospectMap = {};
      prospects.forEach((p) => {
        prospectMap[p.uiid] = p;
      });

      // Build formattedData (same as in handleOpenPreview)
      const formattedData = companies.flatMap((company) => {
        const jobs = company.jobs?.length ? company.jobs : [null];
        return jobs.map((job) => ({
          companyId: company?.uiid,
          jobId: job?.uiid || null,
          companyName: company?.name,
          approvalStatus: company?.approvalStatus,
          companyAddedOn: company?.addedOn,
          website: company?.website,
          industry: company?.industry,
          jobTitle: job?.title,
          jobDescription: job?.description,
          comment: job?.comment || company?.comment || "",
          jobLocation: [
            job?.location?.city,
            job?.location?.state,
            job?.location?.country,
          ]
            .filter(Boolean)
            .join(", "),
          contactDetails: (job?.prospectIds || [])
            .map((id) => {
              const p = prospectMap[id];
              if (!p) return null;
              const phone =
                p?.mobile && (p?.mobile?.code || p?.mobile?.number)
                  ? {
                      code: p.mobile?.code || "",
                      number: p.mobile?.number || "",
                      display: `${p?.mobile?.code || ""} ${
                        p?.mobile?.number || ""
                      }`.trim(),
                    }
                  : null;
              return {
                name: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
                designation: p?.designation || "",
                email: p?.email || "",
                phone: phone,
                // location: [
                //   p?.location?.city,
                //   p?.location?.state,
                //   p?.location?.country,
                // ]
                //   .filter(Boolean)
                //   .join(", "),
                location: p?.location,
              };
            })
            .filter(Boolean),
        }));
      });

      // Check for missing fields
      let hasMissingFields = false;
      const emailCountMap = {};

      formattedData.forEach((job) => {
        job?.contactDetails?.forEach((contact) => {
          const email = contact?.email?.email?.trim().toLowerCase();
          if (email) {
            emailCountMap[email] = (emailCountMap[email] || 0) + 1;
          }
        });
      });

      const issuesFormattedData = [];

      for (const job of formattedData) {
        let errorJobDetails = [];
        const requiredJobFields = ["jobTitle", "jobDescription", "jobLocation"];
        requiredJobFields.forEach((field) => {
          console.log("job[field]", job[field]);
          if (!job[field]?.trim() || job[field] === "-") {
            errorJobDetails.push(`${field} is missing`);
          }
        });

        if (!job?.contactDetails?.length) {
          errorJobDetails.push("No Contacts Added");
        } else {
          const hasDuplicateEmailAcrossJobs = job.contactDetails.some(
            (contact) => {
              const email = contact?.email?.email?.trim().toLowerCase();
              return email && emailCountMap[email] > 1;
            },
          );
          if (hasDuplicateEmailAcrossJobs) {
            errorJobDetails.push("Duplicate Email");
          }
        }

        const approval = job?.approvalStatus;
        const isToday =
          new Date(job?.companyAddedOn).toDateString() ===
          new Date().toDateString();

        if (!approval || !approval.isEnabled || !isToday) {
          // treat as no approval flow
        } else if (approval.status === 1) {
          errorJobDetails.push("Approval Request Pending");
        } else if (approval.status === 3) {
          errorJobDetails.push("Company Rejected");
        }

        // console.log("errorJobDetails", errorJobDetails);
        if (errorJobDetails.length > 0) {
          hasMissingFields = true;
          setMyLeadsErrors((prevErrors) => {
            const existingIndex = prevErrors.findIndex(
              (e) => e.companyName === job?.companyName,
            );
            if (existingIndex !== -1) {
              const updatedErrors = [...prevErrors];
              updatedErrors[existingIndex] = {
                companyName: job?.companyName,
                issues: errorJobDetails,
              };
              return updatedErrors;
            }
            return [
              ...prevErrors,
              { companyName: job?.companyName, issues: errorJobDetails },
            ];
          });
          issuesFormattedData.push(
            formattedData.find((j) => j.companyName === job?.companyName),
          );
        } else
          setMyLeadsErrors((prevErrors) =>
            prevErrors.filter((e) => e.companyName !== job?.companyName),
          );
      }

      if (hasMissingFields) {
        // Some missing → open preview
        setPreviewData(issuesFormattedData);
        setIsPreviewModel(true);
      } else {
        // All filled → show toast
        showToast("Submitted successfully!", "success");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      showToast("Something went wrong while submitting.", "error");
    }
  };
  const rows = companies.flatMap((company) => {
    if (!company?.jobs || company?.jobs.length === 0) {
      return [
        {
          id: company?.uiid,
          companyId: company?.uiid,
          companyName: company?.name || "",
          website: company?.website || "",
          approvalStatus: company?.approvalStatus,
          comment: company?.comment || "",
          companyAddedOn: company?.addedOn || "",
          jobTitle: "-",
          jobLocation: "-",
          jobDescription: "",
          contactDetails: 0,
          jobId: "",
        },
      ];
    }
    return (company?.jobs || []).map((job) => ({
      id: job?.uiid,
      jobId: job?.uiid,
      companyId: company?.uiid,
      companyName: company?.name || "",
      approvalStatus: company?.approvalStatus,
      comment: company?.comment || "",
      website: company?.website || "",
      companyAddedOn: company?.addedOn || "",
      jobTitle: job?.title || "-",
      jobLocation: job?.location
        ? [job?.location?.city, job?.location?.state, job?.location?.country]
            .filter(Boolean)
            .join(", ") || "-"
        : "-",
      jobDescription: job?.description || "",
      contactDetails: job?.prospectIds.length,
      prospectIds: job?.prospectIds || [],
    }));
  });
  function getSiteName(url) {
    try {
      const { hostname } = new URL(url);
      let name = hostname
        .replace(/^www\./, "")
        .split(".")[0]
        .replace(/-/g, " ");
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    } catch {
      return "Link";
    }
  }
  const normalizeUrl = (url) => {
    if (!url) return "#";
    if (!/^https?:\/\//i.test(url)) {
      return "https://" + url;
    }
    return url;
  };

  const filteredRows = rows.filter((row) => {
    if (!searchText.trim()) return true;

    const lowerSearch = searchText.trim().toLowerCase();

    const company = (row?.companyName || "").toLowerCase();
    const title = (row?.jobTitle || "").toLowerCase();
    const location = (row?.jobLocation || "").toLowerCase();

    return (
      company.includes(lowerSearch) ||
      title.includes(lowerSearch) ||
      location.includes(lowerSearch)
    );
  });

  const mappedRows = mapTableRows(filteredRows, columns);

  const rowData = rows.find((item) => item.id === showDataId);
  function getUniquePrimaryEmails(data) {
    if (!Array.isArray(data)) {
      throw new TypeError("Expected an array of records");
    }

    const emails = new Set();

    for (const record of data) {
      const email = record?.["Primary Email"];

      if (
        typeof email === "string" &&
        email.trim() &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ) {
        emails.add(email.trim().toLowerCase());
      }
    }

    return [...emails];
  }
  // const parseCsvFile = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const text = e.target.result;
  //     Papa.parse(text, {
  //       header: true,
  //       skipEmptyLines: true,
  //       complete: (result) => {
  //         const { valid, missing } = validateFileHeaders(result?.data);
  //         if (!valid) {
  //           showToast(
  //             `Missing required columns: ${missing.join(", ")}`,
  //             "error",
  //             4000
  //           );
  //           setCsvFile([]);
  //           setExcelFile([]);
  //           setOpenImportModal(false);
  //           return;
  //         }
  //         // if (result?.data?.length > 100) {
  //         //   showToast(
  //         //     "Only up to 100 records are allowed per upload.",
  //         //     "error",
  //         //     4000
  //         //   );
  //         //   setCsvFile([]);
  //         //   setExcelFile([]);
  //         //   setOpenImportModal(false);
  //         //   return;
  //         // }
  //         // setParsedData(result.data); // save parsed data to state

  //         console.log("result.data",result.data)
  //         setRawParsedData(result.data);
  //       },
  //     });
  //   };
  //   reader.readAsText(file);
  // };
  const parseCsvFile = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const { valid, missing } = validateFileHeaders(result?.data);
          if (!valid) {
            showToast(
              `Missing required columns: ${missing.join(", ")}`,
              "error",
              4000,
            );
            setCsvFile([]);
            setExcelFile([]);
            setOpenImportModal(false);
            return;
          }
          const emailSet = new Set();
          const uniqueData = [];
          for (const row of result.data) {
            const email = row?.["Primary Email"];
            if (
              typeof email === "string" &&
              email.trim() &&
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
            ) {
              const normalizedEmail = email.trim().toLowerCase();

              if (!emailSet.has(normalizedEmail)) {
                emailSet.add(normalizedEmail);
                uniqueData.push(row);
              }
            }
          }
          setRawParsedData(uniqueData);
        },
      });
    };

    reader.readAsText(file);
  };

  // const parseExcelFile = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(data, { type: "array" });
  //     const sheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[sheetName];
  //     const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
  //     const { valid, missing } = validateFileHeaders(jsonData);

  //     if (!valid) {
  //       showToast(
  //         `Missing required columns: ${missing.join(", ")}`,
  //         "error",
  //         4000
  //       );
  //       setOpenImportModal(false);
  //       setCsvFile([]);
  //       setExcelFile([]);
  //       return;
  //     }
  //     // if (jsonData.length > 100) {
  //     //   showToast(
  //     //     "Only up to 100 records are allowed per upload.",
  //     //     "error",
  //     //     4000
  //     //   );
  //     //   setCsvFile([]);
  //     //   setExcelFile([]);
  //     //   setOpenImportModal(false);
  //     //   return;
  //     // }

  //     // setParsedData(jsonData); // save parsed data to state
  //     console.log("jsonData",jsonData)
  //     setRawParsedData(jsonData);
  //   };
  //   reader.readAsArrayBuffer(file);
  // };

  const parseExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      const { valid, missing } = validateFileHeaders(jsonData);
      if (!valid) {
        showToast(
          `Missing required columns: ${missing.join(", ")}`,
          "error",
          4000,
        );
        setOpenImportModal(false);
        setCsvFile([]);
        setExcelFile([]);
        return;
      }
      const emailSet = new Set();
      const uniqueData = [];
      for (const row of jsonData) {
        const email = row?.["Primary Email"];
        if (
          typeof email === "string" &&
          email.trim() &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        ) {
          const normalizedEmail = email.trim().toLowerCase();

          if (!emailSet.has(normalizedEmail)) {
            emailSet.add(normalizedEmail);
            uniqueData.push(row);
          }
        }
      }
      setRawParsedData(uniqueData);
    };

    reader.readAsArrayBuffer(file);
  };

  useEffect(() => {
    const processData = async () => {
      if (rawParsedData.length > 0 && companies.length > 0) {
        const structured = await transformFileData(
          rawParsedData,
          companies,
          loginUserUiid,
        );
        setParsedData(structured);
        // console.log("Structured Parsed Data:", structured);
      }
    };
    processData();
  }, [rawParsedData, companies]);

  const transformFileData = async (parsedData, companies, addedBy) => {
    const groupedByCompany = parsedData.reduce((acc, row) => {
      const companyName = sanitizeString(row["Company Name"]);
      // const companyName = row["Company Name"]?.trim().toLowerCase();
      if (!companyName) return acc;

      if (!acc[companyName]) acc[companyName] = [];
      acc[companyName].push(row);
      return acc;
    }, {});

    // Collect all job IDs to fetch
    const allJobIds = companies
      .flatMap((c) => c.jobs?.map((j) => j.uiid) || [])
      .filter(Boolean);

    // Bulk fetch all jobs at once
    const jobsMap = await fetchJobsByMultipleIds(allJobIds);
    const results = [];

    for (const company of companies) {
      const companyName = sanitizeString(company?.name);
      const rows = groupedByCompany[companyName] || [];

      const job = company?.jobs?.[0]; // pick first job if exists
      const companyId = company?.uiid;
      const jobId = job?.uiid || null;

      // Use bulk fetched data instead of individual API call
      const fullJob = jobId ? jobsMap[jobId] : {};

      let existingProspects = jobId
        ? (fullJob?.prospectIds || []).map((p, idx) => ({
            companyId,
            jobId,
            email: p?.email || "",
            firstName: p?.firstName || "",
            lastName: p?.lastName || "",
            designation: p?.designation || "",
            phone: p?.mobile ? `${p?.mobile?.code} ${p?.mobile?.number}` : "",
            location: p?.location
              ? `${p?.location?.city || ""}, ${p?.location?.state || ""}, ${
                  p?.location?.country || ""
                }`
              : "",
            uiid: p?.uiid || null,
            addedOn: p?.addedOn || null,
          }))
        : [];

      const existingEmails = new Set(
        existingProspects.map((p) => p.email?.email?.toLowerCase()),
      );

      const parsedProspects =
        jobId && rows.length
          ? rows.map((r, idx) => ({
              companyId,
              jobId,
              email: (r["Primary Email"] || r["Email "] || "").toLowerCase(),
              firstName: r["First Name"] || "",
              lastName: r["Last Name"] || "",
              designation: r["Title"] || "",
              phone: r["Contact Phone 1"] || "",
              location: `${r["Contact City"] || ""}, ${
                r["Contact State Abbr"] || ""
              }, ${r["Contact Country"] || ""}`,
              addedBy,
              // uiid: Date.now() + idx,
            }))
          : [];
      // Merge (deduplication still applies)
      let mergedProspects = [
        ...existingProspects,
        ...parsedProspects.filter((p) => !existingEmails.has(p.email)),
      ];
      if (mergedProspects.length > 5)
        mergedProspects = mergedProspects.slice(0, 5);

      // Push into results (even if no job, but only existingProspects allowed)
      results.push({
        companyId,
        companyName: company?.name,
        website: company?.website || "",
        jobId,
        jobTitle: job?.title || null,
        jobDescription: job?.description || null,
        jobLocation: job?.location || "",
        industry: company?.industry || null,
        Prospects: mergedProspects,
      });
    }

    return results;
  };

  const EditModalCallback = (row) => {
    handleOpenEditModal(
      viewData?.jobId,
      viewData?.companyId,
      viewData?.companyName,
    );
    setOpenViewModal(false);
    setViewData(null);
    setOpenEditModal(true);
  };

  const handleEditClose = () => {
    setOpenEditModal(false);
    setShowDataId(null);
    setEditData(null);
  };

  const renderInfoSection = (title, icon, fields = []) => (
    <div className="flex flex-col gap-3">
      <HeaderStyle title={title} icon={icon} />

      <div className="grid grid-cols-2 gap-x-5 gap-y-10">
        {fields.map(({ title: fieldTitle, value }, index) => {
          const isUrl =
            (fieldTitle === "Website" || fieldTitle === "Job Description") ||
            (value &&
              typeof value === "string" &&
              (value.startsWith("http://") ||
                value.startsWith("https://") ||
                value.startsWith("www.") ||
                /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}/.test(
                  value,
                )));

          const isDate =
            value &&
            (value instanceof Date ||
              (!isNaN(Date.parse(value)) && typeof value === "string") && !isUrl);

          return (
            <InfoText
              key={index}
              title={fieldTitle}
              titleProps={{ className: "!text-black" }}
              textWrap={isUrl}
              value={
                <div>
                  {isDate ? (
                    <div className="text-sm text-dark font-medium text-nowrap">
                      {dateFormator(value, "short")}
                    </div>
                  ) : isUrl ? (
                    <div className="text-sm text-blue-600 font-medium text-nowrap">
                      {/* <a
                        href={
                          value.startsWith("http") ? value : `https://${value}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {fieldTitle === "Job Description"
                          ? getSiteName(
                            value.startsWith("http")
                              ? value
                              : `https://${value}`
                          )
                          : "Link"}
                      </a> */}
                      {!value || value === "-" ? (
                        "-"
                      ) : (
                        <a
                          href={
                            value.startsWith("http")
                              ? value
                              : `https://${value}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          {fieldTitle === "Job Description"
                            ? getSiteName(
                                value.startsWith("http")
                                  ? value
                                  : `https://${value}`,
                              )
                            : fieldTitle === "Website"
                              ? value
                              : "Link"}
                        </a>
                      )}
                    </div>
                  ) : (
                    <div className="text-sm text-black font-medium text-wrap">
                      {typeof value === "string" ? formatWords2(value) : value}
                    </div>
                  )}
                </div>
              }
            />
          );
        })}
      </div>
    </div>
  );

  const renderContactSection = (contacts = []) => (
    <div className="flex flex-col gap-3">
      <HeaderStyle title="Contact Details" icon="person" />
      <div className="flex flex-col gap-10">
        {contacts.map((contact, idx) => (
          <div key={idx} className="flex flex-col gap-10">
            <div className="grid grid-cols-2 gap-x-5 gap-y-10">
              <InfoText
                size="sm"
                title="Name"
                value={formatWords2(contact?.name || "")}
                textWrap
              />
              <InfoText
                size="sm"
                title="Designation"
                value={formatWords2(contact?.designation || "")}
                textWrap
              />
              <InfoText
                size="sm"
                title="Location"
                // value={contact.location}
                value={
                  // contact.location
                  //   ? `${contact.location.city || "-"}, ${contact.location.state || "-"
                  //   }, ${contact.location.country || "-"}`
                  //   : "-"
                  contact?.location
                    ? [
                        contact?.location?.city,
                        contact?.location?.state,
                        contact?.location?.country,
                      ]
                        .filter(Boolean)
                        .join(", ") || "-"
                    : "-"
                }
                textWrap
              />
              <InfoText
                size="sm"
                title="Email"
                // value={contact?.email?.email || contact?.email || "-"}
                value={
                  contact?.email?.email || contact?.email ? (
                    <div className="flex items-center">
                      <CopyToClipboard
                        title={contact?.email?.email || contact?.email}
                        content={contact?.email?.email || contact?.email}
                      />
                      <span>{contact?.email?.email || contact?.email}</span>
                    </div>
                  ) : (
                    "-"
                  )
                }
                textWrap
              />
              <InfoText
                size="sm"
                title="Phone"
                value={contact?.phone || ""}
                textWrap
              />
            </div>
            {idx < contacts.length - 1 && <Divider />}
          </div>
        ))}
      </div>
    </div>
  );

  // const handleConfirmDelete = () => {
  //   if (!deleteLeadId) return;

  //   let selectedCompany = companies.find((company) =>
  //     (company.jobs || []).some((job) => job.uiid === deleteLeadId)
  //   );
  //   if (!selectedCompany) {
  //     selectedCompany = companies.find(
  //       (company) => company.uiid === deleteLeadId
  //     );
  //   }

  //   if (!selectedCompany) {
  //     showToast("Company not found!", "error", 2000);
  //     return;
  //   }

  // dispatch(
  //   deleteJobStart({
  //     company: selectedCompany,
  //     jobUiid: deleteLeadId,
  //     onSuccess: () => {
  //       dispatch(
  //         getTodaysCompaniesStart({
  //           limit: 50,
  //           page: 1,
  //           filters: {
  //             uiid: {
  //               type: "AG_COMPANYJOBS",
  //               value: [
  //                 dayjs().startOf("day").toISOString(),
  //                 dayjs().endOf("day").toISOString(),
  //               ],
  //               addedBy: loginUserUiid,
  //             },
  //           },
  //           sort: { addedOn: -1 },
  //         })
  //       );
  //       const todayStart = dayjs().startOf("day").toISOString();
  //       const todayEnd = dayjs().endOf("day").toISOString();
  //       getCompanyJobsCounts("today", [todayStart, todayEnd]);
  //     },
  //   })
  // );
  // setIsPreviewModel(false);
  // setShowDeleteAlert(false);
  // setDeleteLeadId(null);
  // setCompanyName(null);
  // };
  const handleConfirmDelete = async () => {
    if (!deleteLeadId) {
      showToast("Company ID not found!", "error", 2000);
      return;
    }

    const company = companies.find((c) => c.uiid === deleteLeadId);

    if (!company) {
      showToast("Company not found!", "error", 2000);
      return;
    }

    const hasJobs = Array.isArray(company.jobs) && company.jobs.length > 0;

    try {
      setDeleteLoading(true);
      let response;

      if (hasJobs) {
        const jobToDelete = company.jobs[0];
        response = await deleteJobApi({ uiid: jobToDelete.uiid });
      } else {
        response = await deleteCompanyApi({ uiid: company.uiid });
      }

      if (response?.data) {
        dispatch(
          getTodaysCompaniesStart({
            limit: 50,
            page: 1,
            filters: {
              uiid: {
                type: "AG_COMPANYJOBS",
                value: [
                  dayjs().startOf("day").toISOString(),
                  dayjs().endOf("day").toISOString(),
                ],
                addedBy: loginUserUiid,
              },
            },
            sort: { addedOn: -1 },
          }),
        );

        const todayStart = dayjs().startOf("day").toISOString();
        const todayEnd = dayjs().endOf("day").toISOString();
        getCompanyJobsCounts("today", [todayStart, todayEnd]);

        showToast("Deleted successfully!", "success", 2000);
      } else {
        showToast("Failed to delete. Please try again.", "error", 2000);
      }
      setIsPreviewModel(false);
      setShowDeleteAlert(false);
      setOpenViewModal(false);
      setDeleteLeadId(null);
      setCompanyName(null);
    } catch (err) {
      console.error(err);
      showToast("Error deleting. Try again!", "error", 2000);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handlePreviewDeleteClick = (companyId, companyName) => {
    setDeleteLeadId(companyId);
    setCompanyName(companyName);
    setShowDeleteAlert(true);
  };

  const handleViewDeleteClick = (companyId, companyName) => {
    setDeleteLeadId(companyId);
    setCompanyName(companyName);
    setShowDeleteAlert(true);
  };

  const handleOpenEditModal = async (jobId, companyId, companyName) => {
    // If coming from Preview, skip this function to avoid overwriting the valid data passed in handlePreviewEditClick.
    if (isComingFromPreview.current) {
      isComingFromPreview.current = false;
      return;
    }
    setShowDataId(jobId);
    setEditCompanyId(companyId);
    setOpenEditModal(true);
    setLoadingEdit(true);
    setEditCompany({ companyName: companyName, companyId });
    try {
      const job = jobId ? await fetchJobById(jobId) : {};
      const company = companies.find((c) =>
        (c.jobs || []).some((j) => j.uiid === jobId),
      );
      const contacts = (job?.prospectIds || []).map((p) => ({
        name: `${p?.firstName} ${p?.lastName}`,
        designation: p?.designation,
        location: p?.location || "-",
        email: p?.email || "-",
        phone: p?.mobile ? `${p?.mobile?.code} ${p?.mobile?.number}` : "-",
        uiid: p?.uiid,
      }));
      setEditJobData({
        id: job?.uiid,
        companyName: company?.name || "-",
        website: company?.website || "",
        industry: company?.industry || "",
        jobTitle: job?.title || "",
        jobLocation: job?.location
          ? `${job?.location?.city || "-"}, ${job?.location?.state || "-"}, ${
              job?.location?.country || "-"
            }`
          : "-",
        jobDescription: job?.description || "",
        comment: job?.comment || "",
        contactDetails: contacts,
        jobId: job?.uiid,
        companyId: company?.uiid,
      });
    } catch (error) {
      console.error("Failed to fetch job details", error);
      setEditJobData(null);
    } finally {
      setLoadingEdit(false);
    }
  };

  const fetchCompanyJobCounts = () => {
    const todayStart = dayjs().startOf("day").toISOString();
    const todayEnd = dayjs().endOf("day").toISOString();

    const yesterdayStart = dayjs()
      .subtract(1, "day")
      .startOf("day")
      .toISOString();
    const yesterdayEnd = dayjs().subtract(1, "day").endOf("day").toISOString();

    getCompanyJobsCounts("today", [todayStart, todayEnd]);

    setTimeout(() => {
      getCompanyJobsCounts("yesterday", [yesterdayStart, yesterdayEnd]);
    }, 500);
  };

  const handleJobSaved = () => {
    fetchCompanyJobCounts();
  };

  const callFetchTodaysCompanies = () => {
    const today = new Date();
    const action = {
      limit: 50,
      page: 1,
      filters: {
        uiid: {
          type: "AG_COMPANYJOBS",
          value: [
            // dayjs().startOf("day").toISOString(),
            // dayjs().endOf("day").toISOString(),
            getStartOfDay(today),
            getEndOfDay(today),
          ],
          addedBy: loginUserUiid,
        },
      },
      sort: { addedOn: -1 },
    };
    dispatch(getTodaysCompaniesStart(action));
  };

  useEffect(() => {
    callFetchTodaysCompanies();
  }, []);

  const getCompanyJobsCounts = (dateType, dateRange) => {
    const action = {
      coll: "Job",
      useAggregate: true,
      fil: JSON.stringify({
        uiid: {
          type: "AG_COMPANYJOBS_COUNT",
          value: dateRange, // Pass the calculated date range
          addedBy: loginUserUiid,
        },
      }),
      limit: 50,
      page: 1,
      queryMode: "AG_COMPANYJOBS_COUNT",
      dateType,
    };
    dispatch(getTodaysCompanyJobCountsStart(action));
  };

  useEffect(() => {
    // const todayStart = dayjs().startOf("day").toISOString();
    // const todayEnd = dayjs().endOf("day").toISOString();
    // const yesterdayStart = dayjs()
    //   .subtract(1, "day")
    //   .startOf("day")
    //   .toISOString();
    // const yesterdayEnd = dayjs().subtract(1, "day").endOf("day").toISOString();

    //new date function
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const todayStart = getStartOfDay(today);
    const todayEnd = getEndOfDay(today);
    const yesterdayStart = getStartOfDay(yesterday);
    const yesterdayEnd = getEndOfDay(yesterday);
    getCompanyJobsCounts("today", [todayStart, todayEnd]);
    setTimeout(() => {
      getCompanyJobsCounts("yesterday", [yesterdayStart, yesterdayEnd]);
    }, 3000);
  }, []);

  useEffect(() => {
    if (csvFile.length > 0) parseCsvFile(csvFile[0]);
  }, [csvFile]);

  useEffect(() => {
    if (excelFile.length > 0) parseExcelFile(excelFile[0]);
  }, [excelFile]);

  const REQUIRED_COLUMNS = [
    "Company Name",
    "First Name",
    "Last Name",
    "Title",
    "Primary Email",
    // "Contact Phone 1",
    // "Contact City",
    // "Contact State Abbr",
  ];

  const validateFileHeaders = (data) => {
    if (!data || data.length === 0) {
      return { valid: false, missing: REQUIRED_COLUMNS };
    }

    const headers = Object.keys(data[0]).map((h) => h.trim());
    const missing = REQUIRED_COLUMNS.filter((col) => !headers.includes(col));

    return {
      valid: missing.length === 0,
      missing,
    };
  };

  const unmatchedCount = rawParsedData.filter((row) => {
    const companyName = row["Company Name"]?.trim().toLowerCase();
    return !companies.some(
      (company) => company.name?.trim().toLowerCase() === companyName,
    );
  }).length;

  const downloadSampleFile = () => {
    const headers = [
      "Company Name",
      "First Name",
      "Last Name",
      "Title",
      "Primary Email",
      "Contact Phone 1",
      "Contact City",
      "Contact State Abbr",
    ];

    const sampleRow = [
      "Eve Lom",
      "Tom123",
      "Guerriero123454",
      "HR123",
      "tom123@inc.com",
      "+7 4951234545",
      "Howell1",
      "NJ2",
    ];

    const csvContent = headers.join(",") + "\n" + sampleRow.join(",");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sample_leads.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="flex flex-col gap-4 mt-5 flex-1 overflow-hidden">
      <InfoWrapper>
        <InfoCardNewAdv
          title="Total Accounts"
          // value={todayCounts?.totalCompanied || 0}
          // backValue={yesterdayCounts?.totalCompanied || 0} // can use yesterday similarly
          value={todayCounts?.totalAccounts || 0}
          backValue={yesterdayCounts?.totalAccounts || 0} // can use yesterday similarly
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Completed Accounts"
          // value={todayCounts?.totalJobs || 0}
          // backValue={yesterdayCounts?.totalJobs || 0}
          value={todayCounts?.completedAccounts || 0}
          backValue={yesterdayCounts?.completedAccounts || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Pending Accounts"
          // value={todayCounts?.withoutJobsCount || 0}
          // backValue={yesterdayCounts?.withoutJobsCount || 0}
          value={todayCounts?.pendingAccounts || 0}
          backValue={yesterdayCounts?.pendingAccounts || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Total Job Details"
          value={todayCounts?.totalJobs || 0}
          backValue={yesterdayCounts?.totalJobs || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Total Contact Details"
          // value={todayCounts?.prospects || 0}
          // backValue={yesterdayCounts?.prospects || 0}
          value={todayCounts?.totalContacts || 0}
          backValue={yesterdayCounts?.totalContacts || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Valid Emails"
          // value={todayCounts?.verifiedProspects || 0}
          // backValue={yesterdayCounts?.verifiedProspects || 0}
          value={todayCounts?.validContacts || 0}
          backValue={yesterdayCounts?.validContacts || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Invalid Emails"
          // value={todayCounts?.invalidfieldProspects || 0}
          // backValue={yesterdayCounts?.invalidfieldProspects || 0}
          value={todayCounts?.invalidContacts || 0}
          backValue={yesterdayCounts?.invalidContacts || 0}
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Yet To Validate Emails"
          // value={todayCounts?.unverifiedProspects || 0}
          // backValue={yesterdayCounts?.unverifiedProspects || 0}
          value={todayCounts?.notVerifiedContacts || 0}
          backValue={yesterdayCounts?.notVerifiedContacts || 0}
          isLoading={loading}
        />
      </InfoWrapper>

      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        {/* <div className="flex-1 overflow-auto shadow-tableset">   */}
        <TableAdv
          columns={columns}
          showSlNo
          rows={mappedRows}
          defaultSelectedRows={showDataId ? [showDataId] : []}
          serverSerchValue={searchText}
          enableKeyboardNavigation={true}
          page={page}
          limit={limit}
          handleLimitChange={handleLimitChange}
          setPage={setPage}
          serverOnSearch={(key, val) => setSearchText(val)}
          toolbarRight={{
            search: true,
            filter: true,
            download: false,
            add: [
              {
                component: (
                  <div className="flex gap-3">
                    <div className="flex justify-end items-end">
                      <Button
                        title="Import from Excel"
                        size="sm"
                        icon={"place_item"}
                        onClick={() => setShowUploadModal(true)}
                      />
                    </div>
                  </div>
                ),
              },
            ],
            order: ["search", "add", "filter"],
          }}
        />
        {/* </div> */}
        {rowData && (
          <div className="w-lg shadow p-4 overflow-auto flex flex-col gap-10">
            {renderInfoSection("General Details", "person", [
              {
                title: "Account Name",
                value: formatWords2(editJobData?.companyName),
              },
              {
                title: "Job Title",
                value: formatWords2(editJobData?.jobTitle),
              },
              { title: "Website", value: editJobData?.website },
              {
                title: "Job Location",
                value: formatWords2(editJobData?.jobLocation),
              },
              { title: "Job Description", value: editJobData?.jobDescription },
            ])}

            {renderContactSection(editJobData?.contactDetails)}
            <div className="flex justify-end">
              <Button title="Close" onClick={() => setShowDataId(null)} />
            </div>
          </div>
        )}
      </div>

      <div className="flex justify-center gap-3">
        <Button
          title={"Preview"}
          variant="outlined"
          // onClick={() => setIsPreviewModel(true)}
          onClick={handleOpenPreview}
        />
        <Button
          title={"Submit"}
          // onClick={() => setIsPreviewModel(true)}
          onClick={handleSubmit}
        />
      </div>
      <div>
        {/* Upload Modal */}
        <Modal
          title="Upload any one file either excel or csv ?"
          isOpen={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          width="max-w-2xl"
        >
          <div className="flex justify-center gap-4 py-5">
            <FormFieldSet
              type="fileButton"
              title={"Upload Excel File"}
              accept=".xls,.xlsx"
              noTitle
              value={excelFile}
              onChange={setExcelFile}
            />
            <FormFieldSet
              type="fileButton"
              color="info"
              title={"Upload CSV File"}
              accept=".csv"
              noTitle
              value={csvFile}
              onChange={setCsvFile}
            />

            <Button
              title={"Cancel"}
              color="black"
              variant="outlined"
              onClick={() => setShowUploadModal(false)}
            />
          </div>
          <div className="text-gray-500 text-sm text-center">
            ⓘ You can upload a maximum of <strong>100 records</strong> per file.
          </div>
          <div className="flex items-center justify-center mt-5">
            <Button
              title={"Download Sample File"}
              color="info"
              variant="outlined"
              onClick={downloadSampleFile}
            />
          </div>
        </Modal>

        <Alert
          title={"Delete Details"}
          isOpen={showDeleteAlert}
          onClose={() => {
            setShowDeleteAlert(false);
            setDeleteLeadId(null);
            setCompanyName(null);
          }}
          acceptButton={{
            show: true,
            title: "Delete",
            onClick: handleConfirmDelete,
          }}
          description={
            <>
              Are you sure you want to delete{" "}
              <span className="font-[900] ">{formatWords2(companyName)}</span>{" "}
              from my Companies list?
            </>
          }
        />

        <Modal
          showCloseButton={false}
          isOpen={showDeleteAlert}
          onClose={() => {
            setShowDeleteAlert(false);
            setDeleteLeadId(null);
            setCompanyName(null);
          }}
        >
          <div className="text-center my-3">
            <p>Are you sure you want to delete</p>
            <p className="text-info">"{companyName}"</p>
            <p>from my Companies list?</p>
            <div className="flex justify-center items-center gap-3 mt-8">
              <Button
                title="Cancel"
                variant="outlined"
                color="black"
                onClick={() => {
                  setShowDeleteAlert(false);
                  setDeleteLeadId(null);
                  setCompanyName(null);
                }}
              />
              <Button
                title="Delete"
                onClick={() => {
                  setShowDeleteAlert(false);
                  setDeleteLeadId(null);
                }}
              />
            </div>
          </div>
        </Modal>

        {/* View Modal */}
        <Modal
          title={`${formatWords2(editComapany?.companyName || "")}`}
          isOpen={openViewModal}
          onClose={() => {
            setOpenViewModal(false);
            setViewData(null);
            setShowDataId(null);
          }}
          width="xl:max-w-5xl 2xl:max-w-7xl"
        >
          {/* <ViewLeadModal
            data={newViewData}
            // onEdit={() => EditModalCallback(viewData)} //
            onEdit={EditModalCallback}
          /> */}
          {!newViewData ? (
            <div className="flex justify-center items-center py-10">
              Loading company data...
            </div>
          ) : (
            <ViewLeadModal
              data={newViewData}
              onEdit={EditModalCallback}
              onDelete={handleViewDeleteClick}
            />
          )}
        </Modal>

        {/* Edit Modal */}
        <Modal
          title={`${formatWords2(editComapany?.companyName) || ""}`}
          isOpen={openEditModal}
          onClose={handleEditClose}
          width="w-full"
        >
          {loadingEdit ? (
            <div className="flex justify-center py-10">Loading...</div>
          ) : (
            <JobDetailsModal
              data={editJobData}
              companyId={editCompanyId}
              onClose={handleEditClose}
              isLoading={loading}
              callFetchTodaysCompanies={callFetchTodaysCompanies}
              enableLocationRestrictionCheck={true}
              onJobCountUpdate={handleJobSaved}
            />
          )}
        </Modal>

        <Modal
          showCloseButton={false}
          isOpen={openImportModal}
          closeOnOutsideClick={true}
          onClose={() => setOpenImportModal(false)}
          width="max-w-7xl"
        ></Modal>
        <Backdrop isOpen={loading || deleteLoading}>
          <LogoLoader />
        </Backdrop>

        <Modal
          title="Import"
          isOpen={excelFile.length > 0 || csvFile.length > 0}
          onClose={() => setExcelFile([]) || setCsvFile([])}
          width="w-full max-w-7xl"
        >
          <ImportModal
            // onCancel={() => setOpenImportModal(false)}
            onCancel={() => {
              setExcelFile([]);
              setCsvFile([]);
              setParsedData([]);
              setShowUploadModal(false);
            }}
            parsedData={parsedData}
            setParsedData={setParsedData}
            callFetchTodaysCompanies={callFetchTodaysCompanies}
            unmatchedCount={unmatchedCount}
            onJobCountUpdate={handleJobSaved}
          />
          <div>
            <p>Uploaded File:</p>
            {csvFile.length > 0 && <p>{csvFile[0].name}</p>}
            {excelFile.length > 0 && <p>{excelFile[0].name}</p>}
          </div>
        </Modal>

        <Modal
          isOpen={isModalOpen}
          title={"Notes"}
          onClose={() => setIsModalOpen(false)}
          width="max-w-3xl"
        >
          {notesData}
        </Modal>

        <Modal
          title="Leads Preview"
          isOpen={isPreviewModal}
          onClose={() => setIsPreviewModel(false)}
          // width="max-w-7xl"
          width="max-w-[100rem] mx-auto"
        >
          <div className="w-full max-h-[70vh] flex flex-col overflow-hidden">
            {myLeadsErrors.length > 0 && (
              <div className="bg-amber-100 text-black-700 px-4 py-3 rounded relative mb-4">
                <strong className="font-bold">Issues:</strong>
                <table className="mt-2 w-full border-collapse">
                  <tbody>
                    {myLeadsErrors.map((error, index) => (
                      <tr key={index}>
                        <td className="pr-2 align-top font-semibold">
                          {formatWords2(error.companyName)}:
                        </td>
                        <td className="align-top text-red-600 text-base">
                          {error.issues.join(", ")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <MyLeadsPreview
              previewData={previewData}
              onEdit={handlePreviewEditClick}
              onDelete={handlePreviewDeleteClick}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default MyLeads;
